import React, {useEffect, useState} from "react";
import { Card, Col, Row, Steps } from "antd";

import "../OpenAi.scss";
import {Link, useParams} from "react-router-dom";
import {
  FormOutlined
} from "@ant-design/icons";

const { Step } = Steps;

const GenerateContentContainer = ({
  containerClassName = "",
  showSteps = true,
  steps = [],
  currentStep = 0,
  navSideBar = false,
    list = [],
    selectionHandler,
    selectedChat,
    handleResetChat,
  ...props
}) => {
  const [search, setSearch] = useState("");
  const filteredChats = list.filter(chat =>
      chat?.title?.toLowerCase().includes(search.toLowerCase())
  );


  return (
    <>
      {navSideBar ? (
        <>
          <Row
            justify={"start"}
            className={` ${containerClassName} activeNavBar`}
          >
            <Col span={4} className="navbar-cb">
              <div className="sidebar-nav">
                <div className="_search-container">
                  <p className="newChat" onClick={handleResetChat}>
                    <FormOutlined /> New Chat
                  </p>
                  <input
                    type="text"
                    placeholder="Search chats..."
                    className="input-txt"
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
                {/* {search} */}
                <div className={`_menu-item custom-scroll-container scrollbar`}>
                  {filteredChats?.map((chat) => {
                    return (
                      <div
                        key={chat?._id}
                        onClick={() => selectionHandler(chat)}
                      >
                        <Link
                          className={
                            selectedChat?.session_id === chat.session_id
                              ? "active"
                              : undefined
                          }
                          href={`/app/writely-bot/chat-history/${chat?.session_id}`}
                        >
                          {chat?.title}
                        </Link>
                      </div>
                    );
                  })}
                </div>
              </div>
            </Col>
            <Col
              className={`open-ai content-body open-ai-generate-content-container justify-self-center rightContainer`}
              justify="center"
              /* style={{ width: "100%" }} */
              span={20}
            >
              {showSteps && steps.length > 1 && (
                <>
                  <Col className="steps-container steps-container-horizontal mb-10">
                    <Steps current={currentStep}>
                      {steps.map((step, i) => (
                        <Step title={step.name} progressDot={() => i + 1} />
                      ))}
                    </Steps>
                  </Col>

                  <Col className="steps-container steps-container-vertical mb-10">
                    <Steps current={currentStep} labelPlacement="vertical">
                      {steps.map((step, i) => (
                        <Step title={step.name} progressDot={() => i + 1} />
                      ))}
                    </Steps>
                  </Col>
                </>
              )}

              {props.header && <Col className="mb-10">{props.header}</Col>}

              <Card
                className="--custom-card-container"
                title={steps?.[currentStep]?.header}
              >
                {props.children}
              </Card>
            </Col>
          </Row>
        </>
      ) : (
        <Row
          className={`open-ai content-body open-ai-generate-content-container justify-self-center ${containerClassName} ${
            navSideBar ? "activeNavBar" : ""
          }`}
          justify="center"
          style={{ width: "100%" }}
        >
          <Col className="fw" xxl={20}>
            {showSteps && steps.length > 1 && (
              <>
                <Col className="steps-container steps-container-horizontal mb-10">
                  <Steps current={currentStep}>
                    {steps.map((step, i) => (
                      <Step title={step.name} progressDot={() => i + 1} />
                    ))}
                  </Steps>
                </Col>

                <Col className="steps-container steps-container-vertical mb-10">
                  <Steps current={currentStep} labelPlacement="vertical">
                    {steps.map((step, i) => (
                      <Step title={step.name} progressDot={() => i + 1} />
                    ))}
                  </Steps>
                </Col>
              </>
            )}

            {props.header && <Col className="mb-10">{props.header}</Col>}

            <Card
              className="--custom-card-container"
              title={steps?.[currentStep]?.header}
            >
              {props.children}
            </Card>
          </Col>
        </Row>
      )}
    </>
  );
};

export default React.memo(GenerateContentContainer);
